const MENU_CURATION_TASK_INITIAL_STATE = {
  isLoading: false,
  isUpdateLoading: false,
  isDuplicateLoading: false,
  isRequestScrapingReviewLoading: false,
  isUpdateScrapingReviewStatusLoading: false,
  isMenuDocumentDownloading: false,
  duplicateError: false,
  updateError: undefined,
  error: undefined,
  menuDocumentDownloadError: undefined,
  data: undefined,
  locationNames: [],
  isLocationNamesLoading: false,
  locationNamesError: undefined,
  history: {
    isLoading: false,
    error: undefined,
    data: undefined,
  },
  scrapingReviewComments: {
    isLoading: false,
    error: undefined,
    data: undefined,
  },
}

export default MENU_CURATION_TASK_INITIAL_STATE
